import type { GetCauseAuditByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetCauseAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetCauseAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetCauseAuditByIdArgs = {
  id: string;
};

export const useGetCauseAuditById = createQueryHook<
  UseGetCauseAuditByIdArgs,
  GetCauseAuditByIdResponseRow[],
  GetCauseAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getCauseAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ cause_audit: data }),
  graphqlDocument: GetCauseAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
